export default class ColorHelpers {
  /**
   * Mixes a #RRGGBB color towards white, e.g. tint('#69CE8C', 0.92) → '#f3fbf6'.
   * Returns null for anything that isn't a 6-digit hex color.
   */
  static tint = (hex, whiteWeight) => {
    const value = /^#([0-9a-f]{6})$/i.exec(hex?.trim() ?? '')?.[1];

    if (!value) {
      return null;
    }

    const channel = (offset) => {
      const mixed = Math.round(parseInt(value.slice(offset, offset + 2), 16) * (1 - whiteWeight) + 255 * whiteWeight);

      return mixed.toString(16).padStart(2, '0');
    };

    return `#${channel(0)}${channel(2)}${channel(4)}`;
  };
}
